import React, { Component } from 'react'
import ConstainerTitulo from '../../../../../../components/ConstainerTitulo'

import View from 'react-flexbox'
import Close from '@material-ui/icons/Close';
import Check from '@material-ui/icons/Check';
import { Item, TabelaScorpion, ItemCustomRender, DialogPesquisa, RenderCustomForm } from 'scorpion-core';
export default class componentName extends Component {
    constructor(props) {
        super(props)
        this.salvaritem = this.salvaritem.bind(this)
    }
    salvaritem(item) {
        this.props.salvar(item)
    }
    render() {
        const { handleSubmit, customForm, sair, item, propsview, atualValues } = this.props
        

        let rootAtualValues = propsview.rootAtualValues
        if (!rootAtualValues) {
            rootAtualValues = propsview.atualValues;
        }
        return (<View column>
            <ConstainerTitulo
                titulo={item.nomeItem || "Item"}
                acoes={[
                    { label: "Salvar", onClick: handleSubmit(this.salvaritem), icon: <Check /> },
                    { label: "Cancelar", onClick: sair, icon: <Close /> }
                ]}
            >
                <div>
                    <RenderCustomForm componenteRoot={customForm.componenteRoot} propsview={{ ...this.props, rootAtualValues }} />
                </div>
            </ConstainerTitulo>
        </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/TabelaItensCustomForm/CadastroItem/CadastroItem.js